import { initializeApp } from "firebase/app";
import {
  getAuth,
  initializeAuth,
  indexedDBLocalPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { Capacitor } from "@capacitor/core";

const firebaseConfig = {
  apiKey: "AIzaSyDfaCL53O1HLKrP7UVJIxgMTJurelYhtls",
  authDomain: "adoc-webapp.firebaseapp.com",
  projectId: "adoc-webapp",
  storageBucket: "adoc-webapp.firebasestorage.app",
  messagingSenderId: "976024566777",
  appId: "1:976024566777:web:9741790e056c4322215b28",
  measurementId: "G-Q9CP9FE3Y1",
};

// Lazy singletons — initialize on first access
let firebaseApp = null;
let firebaseAuth = null;

export default function getFirebaseApp() {
  if (!firebaseApp) {
    firebaseApp = initializeApp(firebaseConfig);
  }
  return firebaseApp;
}

/**
 * Returns the Firebase Auth instance.
 *
 * On native platforms (Capacitor) we use `initializeAuth` WITHOUT a
 * `popupRedirectResolver`. The default `getAuth()` resolver eagerly loads
 * `gapi.iframes` from apis.google.com, which fails CORS from the
 * `capacitor://localhost` origin and floods the console with:
 *   - "TypeError: undefined is not an object (evaluating 'gapi.iframes.getContext')"
 *   - Cross-origin redirection to http://developers.google.com/ denied
 * Native flows only use `signInWithCredential`, so no resolver is needed.
 *
 * On web we keep the default `getAuth()` which includes the resolver needed
 * for `signInWithRedirect` / `getRedirectResult`.
 */
export function getFirebaseAuth() {
  if (firebaseAuth) return firebaseAuth;
  const app = getFirebaseApp();
  if (Capacitor.isNativePlatform()) {
    firebaseAuth = initializeAuth(app, {
      persistence: [indexedDBLocalPersistence, browserLocalPersistence],
    });
  } else {
    firebaseAuth = getAuth(app);
  }
  return firebaseAuth;
}
